// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as PorterStoreOrderRepoConfig from "./PorterStoreOrderRepoConfig.bs.js";

var dummyOrdersResponse = {
    "orders": [
      {
        "order_uuid": "3c674e1f-d95d-4bd8-b7ea-c4e2c6345e9e",
        "order_number": "DUMMY0000000",
        "status": "PENDING",
        "geo_region_id": 1,
        "total_amount_minor": 59900,
        "currency_code": "INR",
        "requester": {
          "user_id": 1,
          "persona": "DRIVER",
          "details": {
            "name": "Test User",
            "phone": "9000000001"
          }
        },
        "created_at": "2026-03-19T10:30:00Z",
        "updated_at": "2026-03-19T10:30:00Z"
      },
      {
        "order_uuid": "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        "order_number": "DUMMY0000000",
        "status": "PENDING",
        "geo_region_id": 1,
        "total_amount_minor": 89800,
        "currency_code": "INR",
        "requester": {
          "user_id": 2,
          "persona": "DRIVER",
          "details": {
            "name": "Test Driver",
            "phone": "9000000002"
          }
        },
        "created_at": "2026-03-20T09:00:00Z",
        "updated_at": "2026-03-20T09:00:00Z"
      }
    ]
  };

var dummyOrderDetailResponse = {
    "order_uuid": "3c674e1f-d95d-4bd8-b7ea-c4e2c6345e9e",
    "order_number": "DUMMY0000000",
    "status": "PENDING",
    "geo_region_id": 1,
    "total_amount_minor": 89800,
    "currency_code": "INR",
    "requester": {
      "user_id": 1,
      "persona": "DRIVER",
      "details": {
        "name": "Test User",
        "phone": "9000000001"
      }
    },
    "items": [
      {
        "id": 32,
        "order_id": 28,
        "product": {
          "id": 6,
          "code": "POLO-001",
          "name": "Porter Polo Shirt",
          "description": "Official Porter polo shirt for drivers",
          "is_active": true,
          "image_url": "https://cdn.example.com/polo.png"
        },
        "variant": {
          "id": 17,
          "sku": "POLO-001-L",
          "size_code": "L",
          "is_active": true
        },
        "quantity": 1,
        "unit_price_minor": 59900,
        "total_price_minor": 59900,
        "currency_code": "INR",
        "created_at": "2026-03-26T09:16:36.643897Z"
      }
    ],
    "address": {
      "receiver_name": "Test User",
      "receiver_phone": "+919000000001",
      "address_line_1": "123 Test Street, Layout",
      "address_line_2": "Test Area, Test Locality",
      "city": "Chennai",
      "state": "Tamil Nadu",
      "postal_code": "600001"
    },
    "created_at": "2026-03-19T10:30:00Z",
    "updated_at": "2026-03-19T10:30:00Z"
  };

function fetchOrders(param, param$1, param$2, param$3) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyOrdersResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(PorterStoreOrderRepoConfig.PorterStoreOrderListResponseConverter.execute, result);
                        });
            });
}

function fetchOrderDetail(param) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyOrderDetailResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(PorterStoreOrderRepoConfig.PorterStoreOrderDetailResponseConverter.execute, result);
                        });
            });
}

function updateOrder(param, param$1) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyOrderDetailResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(PorterStoreOrderRepoConfig.PorterStoreOrderDetailResponseConverter.execute, result);
                        });
            });
}

function fetchOrderProducts(param) {
  return Promise.resolve({
              TAG: /* Ok */0,
              _0: []
            });
}

function createPaymentLink(param) {
  return Promise.resolve({
              TAG: /* Ok */0,
              _0: undefined
            });
}

function getWalletState(param) {
  return Promise.resolve({
              TAG: /* Ok */0,
              _0: {
                wallet_version_id: 1
              }
            });
}

function payOrderWithWallet(param, param$1) {
  return Promise.resolve({
              TAG: /* Ok */0,
              _0: undefined
            });
}

var PorterStoreOrderRepo = {
  fetchOrders: fetchOrders,
  fetchOrderDetail: fetchOrderDetail,
  updateOrder: updateOrder,
  createPaymentLink: createPaymentLink,
  getWalletState: getWalletState,
  payOrderWithWallet: payOrderWithWallet,
  fetchOrderProducts: fetchOrderProducts
};

export {
  PorterStoreOrderRepo ,
  
}
/* PorterStoreOrderRepoConfig Not a pure module */
